module.exports = __webpack_public_path__ + "img/warning-red.0fae0f37.svg";